// In eine Funktion gekapselt: die Datei wird von mehreren Sections derselben
// Seite eingebunden. Eine Klassendeklaration auf oberster Ebene würfe ab dem
// zweiten Laden „Identifier has already been declared". customElements.define
// ist ohnehin geschützt; so bleibt auch die Klasse selbst lokal.
(() => {
/**
 * <lo-reveal> — Einblenden beim Scrollen
 * ======================================
 *
 * Ersetzt die <gp-animation>-Elemente von GemPages.
 *
 * Wichtiger Unterschied zum Original: GemPages setzte den Inhalt per Inline-Style
 * auf visibility:hidden und machte ihn erst per JavaScript sichtbar. Fiel das
 * Skript aus, war die halbe Seite unsichtbar — auf der Startseite betraf das 18
 * von 23 Sections.
 *
 * Hier versteckt sich das Element erst, nachdem das Skript nachweislich läuft
 * (Attribut data-ready, gesetzt aus dem Konstruktor). Ohne JavaScript ist
 * schlicht alles sichtbar.
 *
 * Verwendung:
 *   <lo-reveal>…</lo-reveal>
 *   <lo-reveal delay="200">…</lo-reveal>   Verzögerung in ms
 */
class LoumeReveal extends HTMLElement {
  constructor() {
    super();
    // Erst hier — also garantiert mit laufendem JS — darf versteckt werden.
    this.setAttribute('data-ready', '');
  }

  connectedCallback() {
    if (this.dataset.observed) return;
    this.dataset.observed = 'true';

    var reduced =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduced || !('IntersectionObserver' in window)) {
      this.show();
      return;
    }

    var self = this;
    this.observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          var delay = parseInt(self.getAttribute('delay') || '0', 10);
          if (delay > 0) {
            window.setTimeout(function () {
              self.show();
            }, delay);
          } else {
            self.show();
          }
          self.observer.disconnect();
        }
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0 }
    );

    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  show() {
    this.classList.add('is-visible');
  }
}

if (!customElements.get('lo-reveal')) {
  customElements.define('lo-reveal', LoumeReveal);
}
})();
